//#region src/assets/smartphone-verified.png
var smartphone_verified_default = "" + new URL("smartphone-verified-B_HOu9c8.png", import.meta.url).href;
//#endregion
export { smartphone_verified_default as default };

//# sourceMappingURL=smartphone-verified.js.map